import React, { useState, useEffect, Fragment } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "react-phone-number-input/style.css";
import Button from "@mui/joy/Button";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";

function ZiinaApplePay({
  checkoutWithZiinaApple,
  checkoutWithZiinaApple2,
  isZiinaApplePaySelected2,
  isZiinaApplePaySelected,
  isShipmentAddress,
}) {
  const { userId, userToken, userEmail, userName, languageCode, countryCode, cartToken, isPurchase } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      <Button
        className="cp-pm-button"
        variant="plain"
        size="sm"
        onClick={() =>
          checkoutWithZiinaApple({
            selected: true,
            payment_by: "ziina_payment",
          })
        }
      >
        <div className="cp-pm-button-card" style={{ padding: "3px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <RadioGroup>
              <FormControlLabel
                style={{ margin: 0 }}
                value={true}
                control={<Radio checked={isZiinaApplePaySelected} />}
              />
            </RadioGroup>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ fontSize: "14px", fontWeight: 400 }}>
                {t("pay_with")} <img src="/google-pay.png" style={{ width: "40px" }} /> or{" "}
                <img src="/apple-pay.png" style={{ width: "45px" }} />
              </span>
            </div>
          </div>
        </div>
      </Button>

      <Button
        className="cp-pm-button"
        variant="plain"
        size="sm"
        onClick={() =>
          checkoutWithZiinaApple2({
            selected: true,
            payment_by: "ziina_payment",
          })
        }
      >
        <div className="cp-pm-button-card" style={{ padding: "3px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <RadioGroup>
              <FormControlLabel
                style={{ margin: 0 }}
                value={true}
                control={<Radio checked={isZiinaApplePaySelected2} />}
              />
            </RadioGroup>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ fontSize: "14px", fontWeight: 400 }}>
                {t("pay_with")} credit or debit card <CreditCardOutlinedIcon style={{ fontSize: "1.1rem" }} />
              </span>
            </div>
          </div>
        </div>
      </Button>
    </>
  );
}

export default ZiinaApplePay;
